export const TAGS = {
  MERCHANT_LIST: 'merchantList',
  MERCHANT_BANK_ACCOUNTS_LIST: 'merchantBankAccountsList',
  MERCHANT_KYB: 'merchantKyb',
  MERCHANT_CRYPTO_PAYOUT_CREATION: 'merchantCryptoPayoutCreation',
  ASSOCIATED_PERSONS: 'associatedPersons',
  REFUND_RESERVE: 'refundReserve',
};
